<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR INSCRIÇÃO' : 'NOVA INSCRIÇÃO (PRESENCIAL)'" titleIcon="fas fa-user-plus">

            <div v-if="!carregado" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>

            <el-form v-else label-position="top" :model="dados" ref="dados" @submit.native.prevent="salvar">

                <el-alert v-if="dados.protocolo" type="success" :closable="false" class="u-mb-15"
                    :title="'Protocolo ' + dados.protocolo + (dados.classificacao ? ' · posição ' + dados.classificacao : '') + ' · ' + dados.pontuacao + ' ponto(s)'"></el-alert>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Processo de inscrição" prop="processo_inscricao_id" :rules="[$requiredChange]">
                            <el-select v-model="dados.processo_inscricao_id" style="width: 100%;" :disabled="modoEdicao" @change="aoTrocarProcesso">
                                <el-option v-for="p in processos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Escolas de interesse">
                            <el-select v-model="dados.instituicoes" multiple filterable style="width: 100%;"
                                :multiple-limit="maxEscolas">
                                <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                            </el-select>
                            <small v-if="maxEscolas">Este processo permite até {{ maxEscolas }} escola(s).</small>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="10">
                        <el-form-item label="Nome do candidato" prop="nome" :rules="[$requiredBlur]">
                            <el-input v-model="dados.nome" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="5">
                        <el-form-item label="Nascimento" prop="data_nascimento" :rules="[$requiredChange]">
                            <el-date-picker v-model="dados.data_nascimento" type="date" value-format="yyyy-MM-dd"
                                format="dd/MM/yyyy" style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="5">
                        <el-form-item label="CPF">
                            <el-input v-model="dados.cpf" v-mask="'###.###.###-##'"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4">
                        <el-form-item label="Telefone" prop="telefone" :rules="[$requiredBlur]">
                            <el-input v-model="dados.telefone" v-mask="['(##) ####-####', '(##) #####-####']"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Responsável" prop="nome_responsavel" :rules="[$requiredBlur]">
                            <el-input v-model="dados.nome_responsavel" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="E-mail">
                            <el-input v-model="dados.email" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <div v-if="campos.length">
                    <h4 class="u-mb-10">Formulário do processo</h4>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8" v-for="c in campos" :key="c.chave">
                            <el-form-item class="u-mt-10" :label="c.label + (c.obrigatorio ? ' *' : '')">
                                <el-select v-if="c.tipo === 'boolean'" v-model="dados.respostas_formulario[c.chave]" style="width: 100%;">
                                    <el-option value="1" label="Sim"></el-option>
                                    <el-option value="0" label="Não"></el-option>
                                </el-select>
                                <el-date-picker v-else-if="c.tipo === 'date'" v-model="dados.respostas_formulario[c.chave]"
                                    type="date" value-format="yyyy-MM-dd" format="dd/MM/yyyy" style="width: 100%;"></el-date-picker>
                                <el-input v-else v-model="dados.respostas_formulario[c.chave]"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>

                <div v-if="dados.pontuacao_detalhe && dados.pontuacao_detalhe.length" class="u-mt-15">
                    <h4 class="u-mb-10">Memória de cálculo da pontuação</h4>
                    <div class="container-table">
                        <table class="table table-striped">
                            <thead><tr><th>Critério</th><th>Valor encontrado</th><th class="u-text-center">Atendeu</th><th class="u-text-center">Pontos</th></tr></thead>
                            <tbody>
                                <tr v-for="(d, i) in dados.pontuacao_detalhe" :key="i">
                                    <td>{{ d.criterio }}</td>
                                    <td>{{ d.valor_encontrado === null ? '—' : d.valor_encontrado }}</td>
                                    <td class="u-text-center">
                                        <span v-if="d.indeterminado">indeterminado</span>
                                        <span v-else>{{ d.atendeu ? 'Sim' : 'Não' }}</span>
                                    </td>
                                    <td class="u-text-center">{{ d.pontos }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="u-text-right u-mt-20">
                    <router-link to="/admin/inscricao"><el-button>CANCELAR</el-button></router-link>
                    <el-button class="u-ml-10" v-if="podeEscrever" type="primary" native-type="submit">SALVAR</el-button>
                </div>
            </el-form>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO D — itens 62 e 69: inscrição presencial e edição. */
export default {
    data: () => ({
        carregado: false,
        processos: [], instituicoes: [], campos: [], maxEscolas: null,
        dados: {
            processo_inscricao_id: null, protocolo: null, nome: '', data_nascimento: '', cpf: '',
            nome_responsavel: '', telefone: '', email: '', instituicoes: [],
            respostas_formulario: {}, pontuacao: 0, pontuacao_detalhe: [], classificacao: null,
            canal: 'presencial', instituicao_cadastro_id: null
        }
    }),
    computed: {
        /**
         * Esconder o botão NÃO é segurança — o backend continua sendo a autoridade.
         * Isso só evita oferecer ao perfil Consulta uma ação que a API vai recusar.
         */
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) },
 modoEdicao () { return !!this.$route.params.id } },
    mounted () {
        const inst = this.$store.state.config.instituicao
        this.dados.instituicao_cadastro_id = (inst && inst.id) ? inst.id : null

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/inscricao/initForm`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.processos = (r.data && r.data.processos) ? r.data.processos : [] }).catch(() => {})

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : [] }).catch(() => {})

        if (this.modoEdicao) this.carregarRegistro()
        else this.carregado = true
    },
    methods: {
        aoTrocarProcesso () {
            const p = this.processos.find(x => x.id === this.dados.processo_inscricao_id)
            this.maxEscolas = p ? p.qtd_max_estabelecimentos : null
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/processo-inscricao/getById/${this.dados.processo_inscricao_id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.campos = (r.data && r.data.campos_formulario) ? r.data.campos_formulario : []
            }).catch(() => {})
        },
        carregarRegistro () {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/inscricao/getById/${this.$route.params.id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                if (reg.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(reg.erro), type: 'warning' })
                    this.$router.push('/admin/inscricao')
                    return
                }
                Object.keys(this.dados).forEach(k => { if (reg[k] !== undefined && reg[k] !== null) this.dados[k] = reg[k] })
                this.dados.data_nascimento = String(reg.data_nascimento || '').substring(0, 10)
                this.dados.instituicoes = (reg.escolas || []).map(e => e.instituicao_id)
                this.dados.respostas_formulario = reg.respostas_formulario || {}
                this.campos = (reg.processo && reg.processo.campos_formulario) ? reg.processo.campos_formulario : []
                this.maxEscolas = reg.processo ? reg.processo.qtd_max_estabelecimentos : null
                this.carregado = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) {
                    window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' })
                    return
                }
                window.eventBus.$emit('loading', true)
                const url = this.modoEdicao
                    ? `${this.$store.state.config.baseUrlApi}/api/inscricao/update/${this.$route.params.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/inscricao/store`

                this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Inscrição salva. Protocolo: ' + (r.data.protocolo || ''), type: 'success' })
                    this.$router.push('/admin/inscricao')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
